<template>
  <div>
    <h1>This is test page</h1>
    <router-link to="/">go back</router-link>
  </div>
</template>

<script>
export default {
  name: "test"
}
</script>

<style scoped>

</style>